import __base_store from '@/store/__base_store'

/**
 * Store de talles.
 */
export default __base_store({
	state: {
		model_name: 'size',
		per_page: 25,
	},
})

